class VideoTitleToggle {
    constructor(videoElement, timelineString = "", titleElement = null) {
        if (!videoElement || !titleElement || this.isInitTitleManager) {
            return;
        }
        this.video = videoElement;
        this.currentTitleDisplay = titleElement;
        this.timeline = [];

        if (timelineString && timelineString.trim() !== "") {
            this.parseTimeline(timelineString.trim());
        }

        this.bindEvent();
        this.video.isInitTitleManager = true;
    }

    bindEvent() {
        let lastSecond = -1;
        this.video.addEventListener("timeupdate", () => {
            const currentSecond = Math.floor(this.video.currentTime);
            if (currentSecond !== lastSecond) {
                lastSecond = currentSecond;
                this.updateTitle();
            }
        });
    }

    // 解析时间轴字符串
    parseTimeline(timelineString) {
        this.timeline = [];
        const segments = timelineString
            .split(",")
            .map((s) => s.trim())
            .filter((s) => s);

        segments.forEach((segment) => {
            const [timeStr, title] = segment.split("#");
            if (timeStr && title) {
                const seconds = this.parseTimeToSeconds(timeStr.trim());
                this.timeline.push({
                    time: seconds,
                    title: title.trim(),
                    timeStr: timeStr.trim(),
                });
            }
        });

        // 按时间排序
        this.timeline.sort((a, b) => a.time - b.time);
    }

    // 将时间字符串转换为秒数
    parseTimeToSeconds(timeStr) {
        const parts = timeStr.split(":").map(Number);
        if (parts.length === 2) {
            return parts[0] * 60 + parts[1]; // mm:ss
        } else if (parts.length === 3) {
            return parts[0] * 3600 + parts[1] * 60 + parts[2]; // hh:mm:ss
        }
        return 0;
    }

    // 根据当前时间获取应该显示的标题
    getCurrentTitle(currentTime) {
        if (this.timeline.length === 0) return null;

        // 找到当前时间对应的标题段
        let currentSegment = null;
        for (let i = 0; i < this.timeline.length; i++) {
            if (currentTime >= this.timeline[i].time) {
                currentSegment = this.timeline[i];
            } else {
                break;
            }
        }

        return currentSegment;
    }

    // 更新标题显示
    updateTitle() {
        const currentTime = this.video.currentTime;
        const currentSegment = this.getCurrentTitle(currentTime);

        if (currentSegment) {
            this.currentTitleDisplay.textContent = currentSegment.title;
        } else {
            this.currentTitleDisplay.textContent = "";
        }
    }
}

function updateVideoTitle(oVideo, oVideoTitle) {
    if (oVideoTitle.dataset.coverTitleType === 'timeline') {
        new VideoTitleToggle(
            oVideo,
            oVideoTitle.dataset.coverTitleTimeline,
            oVideoTitle
        );
    }
}

function initVideoShow202507(oVideoSplide, oVideoThumbnailSplide) {
    const spMain = new Splide(oVideoSplide, {
        pagination: false,
        arrows: false,
        pagination: false,
        lazyLoad: 'nearby',
    });

    const spThumbnail = new Splide(oVideoThumbnailSplide, {
        isNavigation: true,
        arrows: false,
        pagination: false,
    });

    spMain.on("mounted", () => {
        const currentSlide = spMain.Components.Slides.getAt(0).slide;
        const currentVideo = currentSlide.querySelector("video");
        const currentVideoTitle = currentSlide.querySelector(".cover-title");
        if (currentVideo) {
            currentVideo.muted = true;
            currentVideo.play();
        }

        updateVideoTitle(currentVideo, currentVideoTitle);
    });

    spMain.on("move", (newIndex, prevIndex) => {
        const prevSlide = spMain.Components.Slides.getAt(prevIndex).slide;
        const prevVideo = prevSlide.querySelector("video");
        if (prevVideo) {
            prevVideo.pause();
        }

        const currentSlide = spMain.Components.Slides.getAt(newIndex).slide;
        const currentVideo = currentSlide.querySelector("video");
        const currentVideoTitle = currentSlide.querySelector(".cover-title");
        if (currentVideo) {
            currentVideo.muted = true;
            currentVideo.play();

            updateVideoTitle(currentVideo, currentVideoTitle);
        }
    });

    spMain.sync(spThumbnail);
    spMain.mount();
    spThumbnail.mount();
}
